import { defineStore } from "pinia";
import { http } from "./https";
import { getCache, setCache } from '@/cache';

export const usePopularsGamesStore = defineStore("populars-games", {
  state: () => ({
    games: [],
    nextPage: 1,
    isLoaded: false,
  }),
  actions: {
    // Reset pagination for fresh loads
    resetPagination() {
      this.nextPage = 1;
      this.games = [];
      this.isLoaded = false;
    },
    async loadMostCommented(forceRefresh = false) {
      try {
        // If forcing refresh, reset pagination
        if (forceRefresh) {
          this.nextPage = 1;
          this.games = [];
          this.isLoaded = false;
        }

        if(this.nextPage == null){
          return;
        }

        // Try to load from cache for first page only
        const cacheKey = 'populars_games_page_1';
        if (this.nextPage === 1 && !forceRefresh) {
          const cachedData = getCache(cacheKey);
          if (cachedData) {
            this.games = cachedData.games;
            this.nextPage = cachedData.nextPage;
            this.isLoaded = true;
            return true;
          }
        }

        const isFirstPage = this.nextPage === 1;
        const response = await http.get(`/games/most-commented?page=`+this.nextPage);
        const data = response.data;

        this.nextPage = data.next_page_number;
        this.games = this.games.concat(data.games);
        this.isLoaded = true;

        // Cache first page
        if (isFirstPage) {
          setCache(cacheKey, {
            games: data.games,
            nextPage: data.next_page_number,
          }, 'games');
        }

        return true;
      } catch (error) {
        console.error(error);
      }
      return false;
    },
  },
});
